import React from 'react';
import { Page } from '../../../../../shared/Components/Page';
import {PeriodosLogContainer} from './Screen';

export const ConsultarLogView = () =>{

    return (
        <Page title={'Gestion DNs - Consulta LOG'}>{<PeriodosLogContainer/>}</Page>
    )
}